import React from 'react';
import { motion } from 'framer-motion';
import { PieChartIcon, TrendingDownIcon, ShoppingCartIcon, TargetIcon, UtensilsIcon, CalendarIcon, PlayCircleIcon, FileTextIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: PieChartIcon,
    title: 'Plantilla Presupuesto Mensual',
    desc: 'Con gráficos pie y alertas'
  }, {
    icon: TrendingDownIcon,
    title: 'Seguimiento Deudas Snowball',
    desc: 'Paga la más pequeña primero'
  }, {
    icon: ShoppingCartIcon,
    title: 'Gastos Semanales',
    desc: '+ Lista de supermercado'
  }, {
    icon: TargetIcon,
    title: 'Metas de Ahorro',
    desc: 'Con barras de progreso visuales'
  }, {
    icon: UtensilsIcon,
    title: 'Plan Comidas Económicas',
    desc: '7 días ($30/persona)'
  }, {
    icon: CalendarIcon,
    title: 'Calendario de Pagos',
    desc: 'Con recordatorios visuales'
  }, {
    icon: PlayCircleIcon,
    title: 'Guía Inicio Rápido',
    desc: '+ 3 mini-videos de 5min'
  }, {
    icon: FileTextIcon,
    title: 'Formatos Flexibles',
    desc: 'PDFs imprimibles + Google Sheets'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-231">
          <h2 className="text-3xl md:text-5xl font-bold text-purple-dark mb-4" data-id="element-232">
            Lo que recibes hoy
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-233">
            Todo diseñado para ser simple, visual y en tu idioma.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-234">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border-b-4 border-gold hover:shadow-md transition-shadow flex flex-col items-center text-center gap-4" data-id="element-235">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center text-purple" data-id="element-236">
                <item.icon className="w-8 h-8" data-id="element-237" />
              </div>
              <div data-id="element-238">
                <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-239">
                  {item.title}
                </h3>
                <p className="text-sm text-charcoal/70" data-id="element-240">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}